import { c as _c } from "react/compiler-runtime";
import { TextSkeleton } from '@algoacademy/design-system/web/atoms/TextSkeleton';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { Divider } from '@algoacademy/design-system/web/layouts/Divider';
export function LoadingSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TextSkeleton height={30} width={500} className="mb-3" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <header className="grid grid-cols-2 items-center rounded-t-lg border border-slate-200 bg-slate-100 p-6"><TextSkeleton height={20} width={200} count={2} /><TextSkeleton height={45} width="35%" className="ml-[65%]" /></header>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LightCard className="flex w-142 flex-col gap-2"><section className="grid grid-cols-[50px_1fr_50px] gap-2"><TextSkeleton dark={true} /><TextSkeleton dark={true} /><TextSkeleton dark={true} /></section><TextSkeleton height={20} dark={true} /><TextSkeleton height={220} dark={true} /></LightCard>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <main className="space-y-4">{t0}{t1}<div className="flex gap-6">{t2}<LightCard className="flex w-full flex-col gap-3 rounded-lg"><TextSkeleton height={50} count={7} dark={true} className="mb-3" /><Divider /><TextSkeleton height={40} width="30%" className="ml-[70%]" dark={true} /></LightCard></div></main>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}